import { useMemo } from "react";
import { addDays, startOfDay } from "date-fns";
import useFacility from "../../../../utils/hooks/useFacility";

const SHORT_SALE_WINDOW_FACILITIES = ["1241", "1243"];
const SHORT_SALE_WINDOW_DAYS = 31;
const DEFAULT_SALE_WINDOW_DAYS = 90;

interface PassDateLimits {
  minDate: Date;
  maxDate: Date;
  getEndDate: (startDate: Date) => Date;
}

const usePassDateLimits = (dayValidate: number): PassDateLimits => {
  const facilityIds = useFacility();

  return useMemo(() => {
    const today = startOfDay(new Date());
    const saleWindowDays = SHORT_SALE_WINDOW_FACILITIES.includes(facilityIds)
      ? SHORT_SALE_WINDOW_DAYS
      : DEFAULT_SALE_WINDOW_DAYS;

    return {
      minDate: today,
      maxDate: addDays(today, saleWindowDays),
      getEndDate: (startDate: Date) => addDays(startDate, dayValidate),
    };
  }, [facilityIds, dayValidate]);
};

export default usePassDateLimits;
